import { IContainerProps } from 'props';
import styled from 'styled-components';

interface ButtonStyledProps {
  isActive: boolean;
}

export const Container = styled.div<IContainerProps>`
  width: 85%;
  max-width: 100rem;
  border-radius: 15px;
  padding: 1.5rem;
  background: ${({ theme, color }) => theme.colors[color]};

  @media (max-width: 900px) {
    width: -webkit-fill-available;
    margin: 0 1.5rem;
  }

  @media (max-width: 320px) {
    margin: 0 0.5rem;
    padding: 0.5rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .headerContent {
    display: flex;
    justify-content: space-between;

    h1 {
      font-size: 1.5rem;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.primary};
    }

    button {
      background: transparent;
      border: 0;
      padding: 0;
      font-size: 1.3rem;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.gray};
    }
  }

  .summaryItens {
    .titleSummary {
      font-size: 1.7rem;
      color: ${({ theme }) => theme.colors.secondary};
      font-family: 'Futura PT';
      padding: 0;
      font-weight: 600;
      background: none;
      border: none;
      text-align: left;
    }

    .contentAddress {
      .address {
        padding: 0.5rem 1rem;
        font-size: 1.3rem;
        color: ${({ theme }) => theme.colors.tertiary_500};
        border: none;
        background: none;
      }
    }

    .contentCities {
      display: flex;
      gap: 1rem;
      flex-wrap: wrap;
      padding: 0 1rem;
      max-height: 15rem;
      overflow-y: auto;

      .cities {
        display: flex;
        align-items: center;
        background: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.background_white};
        border-color: transparent;
        font-size: 1.1rem;
        padding: 0.4rem 0.4rem;
        border-radius: 0.5rem;
        margin-top: 0.5rem;

        .cityName {
          font-size: 1.3rem;
          font-weight: 500;
          background: none;
          border: none;
          color: ${({ theme }) => theme.colors.background_white};
        }

        .removeCity {
          cursor: pointer;
          color: ${({ theme }) => theme.colors.primary};
          background: ${({ theme }) => theme.colors.yellow_200};
          width: 20px;
          height: 19px;
          border-radius: 100%;
          padding: 0;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;

          svg {
            font-size: 1.1rem;
          }
        }
      }
    }

    .contentTableSummary {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      padding: 0 1rem;
    }
  }

  .containerCheckbox {
    .MuiFormGroup-root {
      display: flex;
      padding: 0 1rem;

      .MuiFormControlLabel-label {
        font-size: 1.2rem;
        color: ${({ theme }) => theme.colors.text_gray};
        cursor: pointer;
      }
    }
  }

  .containerAccordions {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 0.5rem;

    .contentAddress {
      margin: 1rem 0;
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
      }
      .footer {
        display: flex;
        align-items: center;
        gap: 1rem;
        .containerStreet {
          width: 55%;
        }
        .containerNumber {
          width: 10%;
        }
        .containerComplement {
          width: 35%;
        }
      }
    }
  }

  @media (max-width: 700px) {
    .summaryItens .contentCities {
      padding: 0;
    }

    .contentAddress {
      display: flex;
      flex-direction: column;
      margin: 1rem 0;
      .header {
        display: flex;
        flex-direction: column;
      }
      .footer {
        display: flex;
        flex-direction: column;
        .containerStreet,
        .containerNumber,
        .containerComplement {
          width: 100% !important;
        }
      }
    }
    .summaryItens .contentTableSummary {
      padding: 0;
    }

    .summaryItens .contentPresentationLetter button {
      padding: 0.5rem 0;
    }
  }

  @media (max-width: 550px) {
    .containerCheckbox {
      width: 100%;

      .MuiFormGroup-root {
        justify-content: center;
      }
    }

    .containerAccordions .contentPresentationLetter .presentationLetter {
      height: 20rem;
    }
  }

  @media (max-width: 450px) {
    .summaryItens .contentTableSummary {
      grid-template-columns: 1fr 1fr;
    }
  }
`;
export const TableMap = styled.div`
  margin: 1rem;

  .contentTable {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }

  .footerTable {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;

    .addOption {
      grid-column-start: 3;

      button {
        padding: 0.5rem 0.5rem;
        border: none;
        background-color: transparent;
        color: ${({ theme }) => theme.colors.primary};
        font-size: 1rem;
        font-weight: 300;
        text-decoration: underline;
        text-align: center;

        svg {
          font-size: 1.1rem;
        }
      }
    }
  }

  @media (max-width: 700px) {
    margin: 1rem 0 1rem 0;
  }

  @media (max-width: 580px) {
    .contentTable,
    .footerTable {
      grid-template-columns: 1fr 1fr;

      .addOption {
        grid-column-start: 2;
      }
    }
  }
`;

export const ButtonStyled = styled.button<ButtonStyledProps>`
  border: none;
  padding: 0.5rem 0.5rem;
  background-color: transparent;
  color: ${(props) => (props.isActive ? props.theme.colors.tertiary_500 : props.theme.colors.text)};
  font-size: 1.3rem;
  font-weight: 400;
  text-align: left;

  :hover {
    cursor: pointer;
  }

  @media (max-width: 330px) {
    font-size: 1.1rem;
  }
`;
